import React, { useEffect } from "react";
import styles from "./privacy-policy.scss";
import StaticPage from "../static-page/static-page";

export default function PrivacyPolicy() {
  useEffect(() => {
    function onAccordionToggle() {
      let acc, acc1;
      if (typeof window != "undefined") {
        acc = document.getElementsByClassName(styles["accordion"]);
        acc1 = document.getElementsByClassName(styles["accordion1"]);
      }

      for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          this.classList.toggle(styles["active"]);
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

      for (var i = 0; i < acc1.length; i++) {
        acc1[i].addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          this.classList.toggle(styles["active1"]);
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
    }
    onAccordionToggle();
  });
  return (
    <StaticPage>
      <div className={styles["order-con container"]}>
        &nbsp; &nbsp;
        <h2 className={styles['page_padding']}>
          <b>隱私權政策</b>
        </h2>
        <p className={styles['page_padding']}>
          安麗日用品股份有限公司（以下稱安麗）為維護您的隱私權，特制定隱私權政策如下，以載明安麗如何蒐集、處理、利用您的資料。若您對本隱私權政策有任何疑問，歡迎您隨時與安麗聯繫。
        </p>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion1"]}>蒐集資訊的方式</button>
        <div className={styles["panel"]} style={{ maxHeight: "560px" }}>
          &nbsp;
          <h5>
            <b>我們擁有您的個人資料，可能來自以下幾種管道：</b>
          </h5>
          <ol className={styles["B"]}>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)在加入安麗或於安麗消費時，安麗即依申請人確認同意之個資告知事項暨聲明同意(詳細內容如後)書，蒐集其個人資料。
            </li>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)於使用安麗網站的服務時留存的個人資料。
            </li>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)以外之安麗網站使用者於安麗網站提供之個人資料。
            </li>
            <li>藉由進行其他行銷活動取得。</li>
          </ol>
          <div className={styles["text"]}>
            <p>
              {" "}
              您藉由以上各種方式所留存於安麗的個人資料，皆受到本隱私權政策的保護，並受其規範。
            </p>
          </div>
          <h5>
            <b>個資告知事項既聲明同意書</b>
          </h5>
          <p>
            直銷商：
            <a
              href="https://assets.contentstack.io/v3/assets/bltf59a0f025a7625f9/blt0854007dcfdc336c/67bbd8375535699cac4fef43/個資告知事項暨聲明同意書_202502E版_直銷商加入專用.docx"
              target="_blank"
              rel="noreferrer"
            >
              【直銷商個資告知事項暨聲明同意書】
            </a>
          </p>
          <p>
            生活會員：
            <a
              href="https://assets.contentstack.io/v3/assets/bltf59a0f025a7625f9/blt6f4e22fd11812b6d/659ca6ce4dad150da3e573e1/【會員個資告知事項暨聲明同意書】2024.pdf"
              target="_blank"
              rel="noreferrer"
            >
              【會員個資告知事項暨聲明同意書】
            </a>
          </p>
          <p>
            安麗之友：
            <a
              href="https://assets.contentstack.io/v3/assets/bltf59a0f025a7625f9/bltc4fbdcea663f9438/659ca672c3fb27bf1519f688/【安麗之友個資告知事項暨聲明同意書】2024.pdf"
              target="_blank"
              rel="noreferrer"
            >
              【安麗之友個資告知事項暨聲明同意書】
            </a>
          </p>
          <p>
            訪客購物：
            <a
              href="https://assets.contentstack.io/v3/assets/bltf59a0f025a7625f9/bltcb3553ced9c65261/67beb2a65c53291c78316c07/個資告知事項暨聲明同意書_202502E版_訪客線上購物專用.docx"
              target="_blank"
              rel="noreferrer"
            >
              【訪客購物個資告知事項暨聲明同意書】
            </a>
          </p>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>蒐集資訊的範圍</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>依據您與安麗的關係，安麗所蒐集的個人資料範圍會有所不同。</b>
          </h5>
          <ol className={styles["text"]}>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)：包含（1）經直銷商/生活會員/一般顧客(安麗之友)個人同意留存的資料與（2）安麗所認定屬特定目的範圍內的個人資料（其範圍所包含之特定目的類別詳見前述直銷商、生活會員或安麗之友加入之個資告知事項暨聲明同意書）。
            </li>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)以外之使用者：經本人事先同意後而留存的個人資料。
            </li>
            <div className={styles["text"]}>
              <p>
                {" "}
                您可自行選擇是否提供資料及所提供資料的完整性，但若您不提供個人資料或提供之個人資料不完整時，您將可能無法使用部分網站功能或服務。
              </p>{" "}
            </div>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>蒐集資訊的目的</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>安麗蒐集可供識別的個人資料，主要用作以下用途：</b>
          </h5>
          <ol className={styles["C"]}>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)：安麗直銷商、生活會員或一般顧客(安麗之友)所提供個人資料之用途，詳見前述直銷商、生活會員或安麗之友加入之個資告知事項暨聲明同意書。
            </li>
            <li>
              直銷商、生活會員或一般顧客(安麗之友)以外之使用者：當您僅有瀏覽安麗網站時，我們可能會在行銷活動或聯合銷售時運用您相關的網頁活動紀錄或經您同意提供之個人資料。當您成為顧客後，我們將依您所留存的個人資料，依照相關個資告知事項暨聲明同意書之範圍，提供您迅速、優質的購物經驗。
            </li>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>資訊的分享</button>
        <div className={styles["panel"]}>
          &nbsp;
          <h5>
            <b>
              除了本段所載的下列內容外，未獲您的事先同意，我們絕不轉售、出租或以任何其他方式提供或轉讓您的個人資料。任何您所提供的個人資料我們均將存放在國內或境外可信賴的安麗全球總部或其分支機構。
            </b>
          </h5>
          <ol className={styles["C"]}>
            <li>
              直銷商：根據安麗的商業授權，您將獲得專業團隊提供有關直銷事業上的諮詢與建議。為了有效達成上述目的，我們可能會將您所提供的個人資料，適當地提供予您的推薦人或上線直銷商（合稱推薦體系上線）。上述的推薦體系上線皆已同意不會未經授權揭露您的個人資料予任何不相關的第三人，並有義務嚴格遵守本隱私權政策的相關聲明與規定。在一般狀況下，揭露您的個人資料予推薦體系上線將有助於您的直銷事業運作。若您不同意將您的個人資料提供給推薦體系上線，您得選擇拒絕揭露。
            </li>
            <li>
              顧客：為了維持高品質的服務，我們可能會依您留存的個人資料及相關個資同意的範圍與目的，將您的個人資料提供給服務您的配對直銷商、推薦人或推薦體系上線，以確保您從訂購至取得產品的整個過程中，都能有一個美好的購物經驗。上述的配對直銷商、推薦人或推薦體系上線皆已同意不揭露您的個人資料予任何不相關的第三人，並有義務嚴格遵守本隱私權政策的相關聲明與規定。您可以透過更改安麗網站上您的帳戶設定或者點選網站下方的
              <a
                href="/contact-us"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#29698c" }}
              >
                聯絡安麗
              </a>
              ，通知選擇不揭露個人資料予配對直銷商、推薦人或推薦體系上線。
            </li>
            <li>
              一般使用：為有效服務直銷商及顧客，安麗可能會在法令許可的範圍內，將直銷商或顧客的個人資料提供予各分支機構或協力廠商，以協助直銷商發展其直銷事業，及提供顧客優質服務。
            </li>
            <li>
              法令遵循及依法提供：安麗可能在法院命令或政府公權力機關的要求下，被動提供您的個人資料。另外，安麗也保留以下權利，即當我們充分相信有不法活動發生時，將主動對執法單位進行報告，而此時個人資料的揭露將有助於保護更重要的社會安全以及公共利益。
            </li>
          </ol>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>資訊的保護</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              您於安麗系統中的各項資料與帳號，本網站皆以密碼保護，以保障隱私及安全。
            </p>{" "}
          </div>
          <div className={styles["text"]}>
            <p>
              某些狀況之下，本網站以SSL加密系統，保障數據傳輸的安全。安麗會採取適當的措施以防止未經授權的資料存取、竄改、披露或毀損，其中包括對於資料蒐集、處理及利用等實務及其配套安全措施的內部審查工作，以確保儲存個人資料的系統不會遭到未經授權的存取。
            </p>{" "}
          </div>
          <div className={styles["text"]}>
            <p>
              安麗僅准許需要得知相關個人資料的安麗員工、承包商和代理人處理或利用這些資料，並在上述特定目的的範圍內，代表或協助我們處理相關事宜。上述人員都必須遵守保密義務與簽署相關的保密協定，否則可能會遭到處分，包括解僱、民事求償和刑事起訴。
            </p>{" "}
          </div>
          {/* <ol className={styles["C"]}>
            <li>
              直銷商：若您是安麗的直銷商，我們主要會使用您的個人資料以協助您發展安麗事業，包括：推廣、買賣商品或勞務及推薦體系上下線間相互了解、輔導、協助、統整及運作，以及您協助、出席、參與、發展安麗形象、公益活動及其他委外各項調查之相關行為事項資料等。另外安麗為統整及運作安麗事業可能會將您的個人資料進行國際傳輸。
            </li>
            <li>
              非直銷商：當您成為顧客時，我們將依您所留存的個人資料，提供您迅速、優質的購物經驗。當您只是潛在消費者時，我們可能會在行銷活動或聯合銷售時運用您的個人資料。
            </li>
          </ol> */}
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>
          您對資訊得主張或行使的權利
        </button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              您只要在安麗網站上登入您的帳戶，即可查詢、登錄及修改您的個人資料與設定偏好選項。若您發現資料不正確而無法自行更改者，您也可撥打本公司顧客服務專線(02)2175-5166要求我們補充或更正或請求製發複製本（但可能另依安麗規定須付費）。您也可以隨時告知安麗請求停止蒐集、處理或利用您的個人資料；另外，依法或於商業目的上安麗無繼續保留該資料之必要時，您亦可要求我們將其刪除。然而，若您提出的要求依法並非必要者，則我們得拒絕處理您的要求。
            </p>{" "}
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>
          本網站中Cookie與其他技術的運用
        </button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              為提供更適合您需要的服務，本網站與網站服務有可能會使用Cookie的技術，自動接收並且記錄您瀏覽器上的伺服器數值，包括IP
              Address、cookie中的資料及用戶讀取網頁紀錄。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>國際用戶</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              如前所述，您所提供的個人資料可能於安麗總部及全球安麗的各分支機構間移轉或存取，但無論您的個人資料存放於國內或境外，安麗均以本隱私權政策的聲明與規定為標準，並遵守各國相關法令的規定，以最嚴格標準保障您的隱私權。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>兒童隱私權保護</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗特別重視並保護兒童的隱私權需求，我們並鼓勵父母在兒童的網路活動中扮演一個主動積極的角色。本網站絕不會主動或刻意蒐集未滿12歲兒童的個人資料，一旦我們發現有來自兒童的個人資料，我們將會立即刪除。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>退出服務的選擇</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              若您不願意將個人資料留存於本網站中，或者不願再收到有關行銷的業務活動訊息，可以用書面送達的方式，或來電聯絡本公司辦理。
            </p>
          </div>
          <div className={styles["text"]}>
            <p>
              我們將於收到您停止使用資料的通知並確認您的身份後立即受理，於系統及作業合理期間內通知服務您的推薦體系上線、公司內部各部門、儲運中心及各協力廠商的相關人員停止相互使用您的資料，並在電腦控管系統中進行必要的修正。
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
        <button className={styles["accordion"]}>有關本隱私權政策的變更</button>
        <div className={styles["panel"]}>
          &nbsp;
          <div className={styles["text"]}>
            <p>
              安麗將視所提供服務內容之變更、技術發展的狀況以及法令的變更，在保護直銷商及顧客的隱私權前提下，有權隨時修改本政策，更新後並於本網站公告，但不另個別通知。(202207A版)
            </p>
          </div>
        </div>
        <div className={styles["link-top"]}></div>
      </div>
      <script
        async
        type="text/javascript"
        src="https://code.jquery.com/jquery-3.6.0.min.js"
        integrity="sha384-vtXRMe3mGCbOeY7l30aIg8H9p3GdeSe4IFlP6G8JMa7o7lXvnz3GFKzPxzJdPfGK"
        crossorigin="anonymous"
      ></script>
      <script
        async
        src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
        integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n"
        crossorigin="anonymous"
      ></script>
      <script
        async
        src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
        integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
        crossorigin="anonymous"
      ></script>
    </StaticPage>
  );
}
